export const title = 'Your hair says keep going';
export const body =
  'Don’t give up on your perfectly customized routine—your hair is counting on it.';
export const continueCTA = "Let's keep customizing";
export const exitCTA = 'Nope, I’m gone';
